var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.304688H5C3.61929 0.304688 2.5 1.42397 2.5 2.80469V17.8047C2.5 19.1854 3.61929 20.3047 5 20.3047H15C16.3807 20.3047 17.5 19.1854 17.5 17.8047V2.80469C17.5 1.42398 16.3807 0.304688 15 0.304688ZM6.25 5.30469H13.75C14.0952 5.30469 14.375 5.58451 14.375 5.92969C14.375 6.27487 14.0952 6.55469 13.75 6.55469H6.25C5.90482 6.55469 5.625 6.27487 5.625 5.92969C5.625 5.58451 5.90482 5.30469 6.25 5.30469ZM5.625 8.42969C5.625 8.08451 5.90482 7.80469 6.25 7.80469H13.75C14.0952 7.80469 14.375 8.08451 14.375 8.42969C14.375 8.77487 14.0952 9.05469 13.75 9.05469H6.25C5.90482 9.05469 5.625 8.77487 5.625 8.42969ZM6.25 10.3047H13.75C14.0952 10.3047 14.375 10.5845 14.375 10.9297C14.375 11.2749 14.0952 11.5547 13.75 11.5547H6.25C5.90482 11.5547 5.625 11.2749 5.625 10.9297C5.625 10.5845 5.90482 10.3047 6.25 10.3047ZM6.25 12.8047H10C10.3452 12.8047 10.625 13.0845 10.625 13.4297C10.625 13.7749 10.3452 14.0547 10 14.0547H6.25C5.90482 14.0547 5.625 13.7749 5.625 13.4297C5.625 13.0845 5.90482 12.8047 6.25 12.8047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.8319bcd2a86e8836e42f96d66ac82758.svg";
export { ForwardRef as ReactComponent };